import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MaterialsUKService } from '../materialsuk-service';
import { MatTableDataSource } from '@angular/material/table';
import { CustomfilterPipe } from '../../cms-common/Pipes/customfilter.pipe';
import { OccConfig } from '@spartacus/core';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-mymaterials-orderdetails',
  standalone: false,
  templateUrl: './mymaterials-orderdetails.component.html',
  styleUrl: './mymaterials-orderdetails.component.scss',
})
export class MymaterialsOrderdetailsComponent {
  filterValues = {
    search: '',
    filterbyproduct: [''],
    filterbystatus: [''],
  };
  valformsummary: any;
  togglefilterView: boolean = false;
  togglesortView: boolean = false;
  count = 0;
  isLoading: boolean = false;
  sortvalue: string = '';
  selectedorderactive: any;
  selectedstatus: any[] = [];
  dataSource: any = [];
  materialDeliveriesdataSource= new MatTableDataSource<any>();

  dataSourceWithPageSize = new MatTableDataSource<any>();
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  sortedData: any;
  pageSize: number = 6;
  currentPage: number = 1;
  getfilterdata: any;
  apiresponse: any;
  filteredData1: any;
  getstatus: any;
  totalLength: number = 0;
  displayedColumns: string[] = ['combined'];
  materialsDeliveryColumns:string[]=['status', 'deliveryDate', 'items','trackingLink'];
  
  dropdownValue: any;
  firstvalue: any;
  rightsectionresponse: any;
  digitalMaterialsList: any;
  printedMaterialsList: any;

  constructor(
    private materialsUkService: MaterialsUKService,protected config: OccConfig,
    public cd: ChangeDetectorRef
  ) {
   
  }

  ngOnInit() {
    this.isLoading = true;
    this.materialsUkService.getMaterialDropdownValue().pipe(distinctUntilChanged()).subscribe((value) => {
      this.dropdownValue = value;
      //this.seasonValue=this.dropdownValue
      this.sortedData = [];
      this.filterValues = {
        search: '',
        filterbyproduct: [''],
        filterbystatus: [''],
      };
      if (this.dropdownValue){
        this.materialsUkService.filterstatus(this.dropdownValue).subscribe((data) => {
          this.getstatus = data;
        });
        this.populateLeftSection(this.dropdownValue);
      } 

      //this.rightsectionresponse="";
    });
  }
  populateLeftSection(dropdownValue: any) {
    this.materialsUkService
      .fetchMaterialOrdersList(dropdownValue)
      .subscribe((value) => {
        this.apiresponse = value;
        this.dataSource = new MatTableDataSource(this.apiresponse.materialsOrderData);
        this.dataSourceWithPageSize = new MatTableDataSource(
          this.apiresponse.materialsOrderData
        );
        this.resetFilter();
        this.isLoading = false;
        this.cd.detectChanges();
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.resetsort();
        this.totalLength = this.apiresponse.materialsOrderData.length;
        this.updateTableData();
        this.dataSource.sortingDataAccessor = (item: any, property: any) => {
          switch (property) {
            case 'orderDate':
              return new Date(item.orderDate).getTime();
            default:
              return item[property];
          }
        };
        this.firstvalue = this.apiresponse?.materialsOrderData[0]?.orderId;
        /* this.activatedRoute.queryParams.subscribe(params => {   
        this.loadedFromSummary = params;
        if(this.loadedFromSummary.address) {
        this.filterValues.search = this.loadedFromSummary?.address;
        this.applyFilter();
        this.firstvalue = this.dataSource.filteredData[0]?.orderId;
        this.valformsummary = this.loadedFromSummary.address
        }else{
          this.filterValues.search ="";
          this.valformsummary=""
         
        }
    }); */
        if (this.firstvalue) {
          this.openRightSection(this.firstvalue);
          this.selectedorderactive = this.firstvalue;
        } else {
          this.rightsectionresponse = '';
        }
      },
      (error)=>{
        this.isLoading=false;
        this.cd.detectChanges();
      }
    );
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getProgress(deliveredQty: number, totalQty: number) {
    return Math.floor((deliveredQty / totalQty) * 100);
  }

  inputsearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterValues.search = filterValue.trim().toLowerCase();
  }

  applyFilter() {
    this.filteredData1 = new CustomfilterPipe().transform(
      this.apiresponse.materialsOrderData,
      this.filterValues
    );
    this.dataSource = new MatTableDataSource(this.filteredData1);
    this.cd.detectChanges();
    this.dataSourceWithPageSize = new MatTableDataSource(
      this.apiresponse.materialsOrderData
    );
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.totalLength = this.filteredData1.length;
    this.currentPage=1;
    const starti = (this.currentPage - 1) * this.pageSize;
    const endi = starti + this.pageSize;
    this.dataSource.data = this.filteredData1.slice(starti, endi);
  }

  filteropen() {
    event?.stopPropagation();
    this.togglefilterView = !this.togglefilterView;
    this.togglesortView = false;
  }
  sortopen() {
    event?.stopPropagation();
    this.togglefilterView = false;
    this.togglesortView = !this.togglesortView;
  }
  onFilterClick(event: Event) {
    event.stopPropagation();
  }

  incrementcountstatus(event: any, i: number) {
    if (event.target.checked) {
      this.count++;
      this.selectedstatus.push(event.target.value);
      this.filterValues.filterbystatus = this.selectedstatus;
    } else {
      var index = this.selectedstatus.indexOf(event.target.value);
      this.selectedstatus.splice(index, 1);
      this.filterValues.filterbystatus = this.selectedstatus;
      this.count--;
    }
  }

  resetsort() {
    this.sortvalue = '';
    this.sortedData=[];
    this.dataSource.sort = this.sort;
    const temp1 = <HTMLElement>(
      (<unknown>document.getElementById(this.selectedorderactive))
    );
    if (temp1) {
      temp1.classList.add('activeorder');
    }
  }

  resetFilter() {
    this.filterValues.filterbystatus = [''];
    this.selectedstatus = [];
    this.filterValues.filterbyproduct = [];
    this.count = 0;
    this.applyFilter();
  }

  sortTest(val: any) {
    this.sortvalue = val;
    let newdir: string = 'desc';
    if (val == '1to9' || val == '9to1') {
      const sortState: Sort = {
        active: 'orderId',
        direction: val == '1to9' ? 'asc' : 'desc',
      };
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);

      this.onSortClicked();
    } else if (val == 'AtoZ' || val == 'ZtoA') {
      const sortState: Sort = {
        active: 'delLocation',
        direction: val == 'AtoZ' ? 'asc' : 'desc',
      };
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);

      this.onSortClicked();
    } else if (val == 'LeastRecent' || val == 'MostRecent') {
      const sortState: Sort = {
        active: 'orderDate',
        direction: val == 'LeastRecent' ? 'asc' : 'desc',
      };
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);

      this.onSortClicked();
    }
    const temp1 = <HTMLElement>(
      (<unknown>document.getElementById(this.selectedorderactive))
    );
    if (temp1) {
      temp1.classList.add('activeorder');
    }
  }

  onSortClicked() {
    const sortDirection = this.sort.direction;
    const activeColumn = this.sort.active;
    this.sortedData = [...this.apiresponse.materialsOrderData];
    if (this.filteredData1?.length) {
      this.sortedData = [...this.filteredData1];
    }
    if (sortDirection && activeColumn) {
      this.sortedData.sort((a: any, b: any) => {
        const isAsc = sortDirection === 'asc';
        if (activeColumn == 'orderDate') {
          let date1 = parseDate(a[activeColumn]).getTime();
          let date2 = parseDate(b[activeColumn]).getTime();
          return this.compare(date1, date2, isAsc);
        }
        return this.compare(a[activeColumn], b[activeColumn], isAsc);
      });
    }
    this.currentPage = 1;
    const starti = (this.currentPage - 1) * this.pageSize;
    const endi = starti + this.pageSize;
    const paginatedData = this.sortedData.slice(starti, endi);
    this.dataSource.data = paginatedData;
  }

  compare(a: string | number, b: string | number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  //pagination
  goToLastPage() {
    const totalPages = Math.ceil(this.totalLength / this.pageSize);
    this.currentPage = totalPages;
    this.updateTableData();
    this.scrollToTop();
  }
  updateTableData() {
    const starti = (this.currentPage - 1) * this.pageSize;
    const endi = starti + this.pageSize;
    //this.dataSource.data = this.apiresponse.seasonData.slice(starti, endi);
    if (this.sortedData.length) {
      this.dataSource.data = this.sortedData.slice(starti, endi);
    } else {
      if (this.filteredData1?.length > 0) {
        this.dataSource.data = this.filteredData1.slice(starti, endi);
      } else {
        this.dataSource.data = this.apiresponse.materialsOrderData.slice(starti, endi);
      }
    }
  }

  goToFirstPage() {
    this.currentPage = 1;
    this.updateTableData();
    this.scrollToTop();
  }

  getPages(): any {
    const totalPages = Math.ceil(this.totalLength / this.pageSize);
    const pages: any = [];
    const startPage = Math.max(1, this.currentPage - 1);
    const endPage = Math.min(totalPages, startPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    if (endPage < totalPages - 1) {
      pages.push('...');
    }
    if (endPage < totalPages) {
      pages.push(totalPages);
    }
    return pages;
  }
  goToPage(page: number) {
    this.currentPage = page;
    const starti = (page - 1) * this.pageSize;
    //this.dataSource.data = this.apiresponse.seasonData.slice(starti, starti + this.pageSize);
    if (this.sortedData.length) {
      this.dataSource.data = this.sortedData.slice(
        starti,
        starti + this.pageSize
      );
    } else {
      if (this.filteredData1?.length > 0) {
        this.dataSource.data = this.filteredData1.slice(
          starti,
          starti + this.pageSize
        );
      } else {
        this.dataSource.data = this.apiresponse.materialsOrderData.slice(
          starti,
          starti + this.pageSize
        );
      }
    }
    this.scrollToTop();
  }
  previousPage() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  }
  nextPage() {
    const totlpages = Math.ceil(this.totalLength / this.pageSize);
    if (this.currentPage < totlpages) {
      this.goToPage(this.currentPage + 1);
    }
  }
  isFirstPage(): boolean {
    return this.currentPage == 1;
  }
  isLastPage(): boolean {
    return this.currentPage == Math.ceil(this.totalLength / this.pageSize);
  }
  isCurrentPage(page: number): boolean {
    return this.currentPage == page;
  }

  openRightSection(orderId: string) {
    this.selectedorderactive = orderId;

    const temp = <HTMLElement>document.getElementsByClassName('activeorder')[0];
    if (temp) {
      temp.classList.remove('activeorder');
    }
    const temp1 = <HTMLElement>(<unknown>document.getElementById(orderId));
    if (temp1) {
      temp1.classList.add('activeorder');
    }
    this.isLoading = true;
    this.cd.detectChanges();

    this.materialsUkService
      .fetchMaterialOrderDetail(this.dropdownValue, orderId)
      .subscribe((value) => {
        this.rightsectionresponse = value;
        //for material digital and printed materials
        this.digitalMaterialsList = this.rightsectionresponse.materialsOrderData[0].orderedandShippedProducts.digitalMaterials;
        this.printedMaterialsList = this.rightsectionresponse.materialsOrderData[0].orderedandShippedProducts.printedMaterials;
        this.materialDeliveriesdataSource =  new MatTableDataSource(this.rightsectionresponse.materialsOrderData[0].orderedandShippedProducts.shipments[0].materialsShipmentDetails);
        this.updateDisplayedColumns();
        this.isLoading = false;

        const mobileback = <HTMLElement>document.getElementById('backbtn');
        const mobiletemp = <HTMLElement>document.getElementById('rightsection');
        const left = <HTMLElement>document.getElementById('leftsection');
        left?.classList.add('lefthide');
        mobiletemp?.classList.remove('mobileright');
        mobileback?.classList.add('backhide');
        this.cd.detectChanges();
      },
      (error)=>{
        this.isLoading=false;
        this.cd.detectChanges();
      }
    );
  }
  updateDisplayedColumns() {
    this.materialsDeliveryColumns = this.materialsDeliveryColumns.filter((col)=> col !== 'trackingLink');
    if(this.materialDeliveriesdataSource?.data?.every((row: any) => row?.status === 'In progress' || row.status === 'Back order' || row.status === 'Pre-Ordered')){
      this.materialsDeliveryColumns = this.materialsDeliveryColumns.filter((col)=> col !== 'trackingLink');
      
    }
    else {
     this.materialsDeliveryColumns.push('trackingLink');
    }
  }
  getMedia(media:string){
    return this.config.backend?.occ?.baseUrl + media;
  }
  showDeliveries():boolean{
    return this.rightsectionresponse.materialsOrderData[0].orderedandShippedProducts.shipments.length > 0 && this.rightsectionresponse.materialsOrderData[0].orderedandShippedProducts.shipments[0].materialsShipmentDetails.length > 0;
  }
}
function parseDate(date: string):Date {
  const [day,month,year] = date.split('/').map(Number);
  return new Date(year,month-1,day);
}
